import React, { Component } from 'react';

import './App.css';

class Project extends Component {
  render() {
    return (
    <div className="Project">
        <p>
            <div class="well well-lg "><a href={`./${this.props.route}`} class="btn btn-primary btn-lg">{this.props.title}</a></div>
        </p>
    </div>
    );
  }
}

export default Project;
